export const EnvironmentConfig = {
  buyerClientId: 'D1033E24-148A-49CD-AF40-7D1A72CF9A2B',
  sellerClientId: '15360CFC-0304-462E-B83B-72AC1032BE10',
  baseApiUrl: 'https://westeurope-production.ordercloud.io',
  apiMiddlewareUrl: 'https://dayco-aftermarket-mw.azurewebsites.net/',
  firebaseUrl: 'https://firebasestorage.googleapis.com/v0/b/react-http-51a82.appspot.com/o/',
  gaTrackingId: 'G-3WJGF7HL4X',
};
